import classNames from 'classnames';
import { get, pick } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import styles from './VideoBlurActive.module.css';
import { CropStateType } from '../../../Pages/Flo/Flo.types';
import { getBlurElementPosition } from '../../../Common/Common.utils';
import {
	FLO_ELEMENT_BLUR_TYPE,
	FLO_ELEMENT_SPOTLIGHT_TYPE,
	FLO_ELEMENT_HIGHLIGHT_TYPE,
} from '../../../Common/Common.constants';
import { Opacity } from '@mui/icons-material';

const BASE_INTENSITY = 7;
const BASE_INTENSITY_MULTIPLIER = 13;
const isDev = process.env.NODE_ENV === 'development';

const VideoBlurActive = ({
	elementType,
	element,
	width,
	height,
	offsetWidth,
	offsetHeight,
	isCropped,
	appliedCrop,
}: {
	elementType?: string;
	element: unknown;
	width: number;
	height: number;
	offsetWidth: number;
	offsetHeight: number;
	isCropped?: boolean;
	appliedCrop?: CropStateType;
}) => {
	const dispatch = useDispatch();
	const [points, updatePoints] = useState<{
		height: number;
		width: number;
		left: number;
		top: number;
		path?: string;
	}>({
		height: 0,
		width: 0,
		left: 0,
		top: 0,
		path: '',
	});
	const type: string = get(element, 'shape', 'rectangle');
	let left = offsetWidth;
	let top = offsetHeight;

	const isBlurElement = elementType === FLO_ELEMENT_BLUR_TYPE;
	const isSpotlightElement = elementType === FLO_ELEMENT_SPOTLIGHT_TYPE;
	const isHighlightElement = elementType === FLO_ELEMENT_HIGHLIGHT_TYPE;
	const isBlurOrSpotlight = isBlurElement || isSpotlightElement || isHighlightElement;
	const intensity = get(element, 'intensity') || 1;
	const finalIntensity = BASE_INTENSITY + (intensity * BASE_INTENSITY_MULTIPLIER) / 100;
	const color = get(element, 'color', '#000000');

	useEffect(() => {
		if (!isBlurOrSpotlight) return;
		const newPosition = getBlurElementPosition({
			isCropped,
			appliedCrop,
			element,
			width,
			height,
			offsetHeight,
			offsetWidth,
		});
		updatePoints(newPosition);
	}, [
		isCropped,
		appliedCrop,
		updatePoints,
		isBlurOrSpotlight,
		element,
		height,
		width,
		offsetHeight,
		offsetWidth,
		type,
	]);

	//@ts-ignore
	if (!isBlurOrSpotlight || !points.width || !points.height) return <></>;

	return (
		<div
			style={{
				height: height - offsetHeight * 2,
				width: width - offsetWidth * 2,
				// top: offsetHeight,
			}}
			className={classNames(styles.wrapper, {
				[styles.spotLightWrapper]: isSpotlightElement,
			})}
		>
			{isSpotlightElement ? (
				<svg className={styles.spotLightSvg}>
					<path className={styles.spotLightPath} d={points.path}></path>
				</svg>
			) : (
				<div
					className={classNames(styles.elementWrapper, {
						[styles.spotLightElement]: isSpotlightElement,
					})}
					style={{
						// @ts-ignore
						'--data-intensity': isHighlightElement?0:finalIntensity,
						...points,
					}}
				>
					{ isHighlightElement && (<>

						{type === 'circle' ? (
						<div
							style={{...pick(points, ['height', 'width']),
								backgroundColor: color,
								opacity: 0.3,
							}}
							className={classNames(styles.circle, {
								[styles.editing]: isDev,
							})}
						></div>
					) : (
						<div
							style={{...pick(points, ['height', 'width']),
								backgroundColor: color,
								opacity: 0.3,
							}}
							className={classNames(styles.rectangle, {
								[styles.editing]: isDev,
							})}
						></div>
					)}
					
					</>)}
					{ !isHighlightElement && (<>

						{type === 'circle' ? (
						<div
							style={pick(points, ['height', 'width'])}
							className={classNames(styles.circle, {
								[styles.editing]: isDev,
							})}
						></div>
					) : (
						<div
							style={pick(points, ['height', 'width'])}
							className={classNames(styles.rectangle, {
								[styles.editing]: isDev,
							})}
						></div>
					)}
					
					</>)}
					
				</div>
			)}
		</div>
	);
};

export default React.memo(VideoBlurActive);
